module.exports = __webpack_public_path__ + "static/media/1.cd8d3459.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/1.png
// module id = 691
// module chunks = 0